(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-mobile-menu-tab"] && !Shopify.designMode) return;
  try {
    const getDocumentTop = (element) => element.getBoundingClientRect().top + window.scrollY;

  const initializeProductMobileMenu = () => {
    const menu = document.querySelector('.mobile-menu-tab');
    const paymentButton = document.querySelector('.shopify-payment-button');
    const sectionElements = ['section1', 'section2', 'section3'].map((id) => document.getElementById(id));

    if (!menu || !paymentButton || sectionElements.some((element) => !element)) {
      return;
    }

    const navigationLinks = menu.querySelectorAll('.flex a');
    const paymentButtonTop = getDocumentTop(paymentButton);
    const sectionTops = sectionElements.map((element) => getDocumentTop(element) - 150);
    const isMobile = window.innerWidth <= 700;

    const setActiveLink = (activeIndex) => {
      navigationLinks.forEach((link, linkIndex) => {
        link.classList.toggle('active', linkIndex === activeIndex);
      });
    };

    const updateMenuVisibility = () => {
      const visibilityClass = isMobile ? 'top' : 'bottom';
      const isVisible = isMobile
        ? window.scrollY > paymentButtonTop
        : window.scrollY >= 1000;

      menu.classList.toggle(visibilityClass, isVisible);
    };

    const updateActiveLink = () => {
      const scrollTop = window.scrollY;

      if (scrollTop > sectionTops[0] && scrollTop <= sectionTops[1]) {
        setActiveLink(0);
      } else if (scrollTop > sectionTops[1] && scrollTop <= sectionTops[2]) {
        setActiveLink(1);
      } else if (scrollTop >= sectionTops[2]) {
        setActiveLink(2);
      }
    };

    const handleScroll = () => {
      updateMenuVisibility();
      updateActiveLink();
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  document.querySelectorAll('.to-top-icon').forEach((icon) => {
    icon.addEventListener('click', scrollToTop);
  });

  document.addEventListener('DOMContentLoaded', initializeProductMobileMenu);
  } catch(e) { console.error(e); }
})();

})();
